import { addMinutes, isAfter } from 'date-fns'
import DateUtils from '@/utils/date'
import {
  bidFileTypeDict,
  kpbProjectStatusDict,
  reviewModelDict
} from '@/dictionary/project/kpb-project'
import { quoteOpenStatusDict } from '@/dictionary/hall/open-bid-hall'

/**
 * 获取商务文件解密设置信息
 */
const getBidDecryptConfig = (kpbProject, systemMillisecond) => {
  const startTime = kpbProject.timeInfo.bidOpenStartTime
  const endTime = addMinutes(
    new Date(DateUtils.safeDate(startTime)),
    kpbProject.projectInfo?.bidDecryptMin || 10
  )
  const now = new Date(systemMillisecond)
  // 解密时间已截至
  const decryptExpired = isAfter(now, endTime)
  // 是否已开启开标一览表
  const markOpened =
    kpbProject.projectStatus >= kpbProjectStatusDict.OPEN_MARK.value ||
    kpbProject.timeInfo?.openEndTime
  return {
    // 商务文件开始解密时间
    startTime,
    // 商务文件解密结束时间
    endTime,
    decryptExpired,
    markOpened
  }
}

/**
 * 获取报价文件解密设置信息
 */
const getQuoteDecryptConfig = (kpbProject, systemMillisecond) => {
  const startTime = kpbProject.timeInfo.offerOpenStartTime
  const endTime = addMinutes(
    new Date(DateUtils.safeDate(startTime)),
    kpbProject.projectInfo?.offerDecryptMin || 10
  )
  const now = new Date(systemMillisecond)
  // 解密时间已截至
  const decryptExpired = isAfter(now, endTime)
  // 是否已开启开标一览表
  const markOpened =
    kpbProject.offerBidOpenStatus >= quoteOpenStatusDict.OPEN_MARK.value ||
    kpbProject.timeInfo?.offerOpenEndTime
  return {
    startTime,
    endTime,
    decryptExpired,
    markOpened
  }
}

/**
 * 文件解密时间设置
 */
const useFileDecryptTime = (kpbProject, bidFileType, systemMillisecond) => {
  // 如果不是双信封，则没有时间设置
  if (kpbProject.projectInfo.reviewModel !== reviewModelDict.DOUBLE.value) {
    return {}
  }
  // 如果是商务文件，则返回商务文件相关的信息
  if (bidFileType === bidFileTypeDict.BUSINESS.value) {
    return getBidDecryptConfig(kpbProject, systemMillisecond)
  }
  // 如果是报价文件，则返回报价文件相关的信息
  if (bidFileType === bidFileTypeDict.QUOTATION.value) {
    return getQuoteDecryptConfig(kpbProject, systemMillisecond)
  }
}

export default useFileDecryptTime
